export const isIOS = () => {
    const agent = window.navigator.userAgent,
        start = agent.indexOf('OS ')
    return (agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1
}

export const isMacOS = () => {
    const agent = window.navigator.userAgent,
        start = agent.indexOf('OS ')
    return agent.indexOf('Mac') > -1 && start > -1
}

export const isApple = () => {
    const agent = window.navigator.userAgent,
        start = agent.indexOf('OS ')
    return (
        (agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1 || agent.indexOf('Mac') > -1) &&
        start > -1
    )
}

export const isAndroid = () => {
    const agent = window.navigator.userAgent,
        start = agent.indexOf('Android ')
    return start > -1
}

export const isHuawei = () => {
    const agent = window.navigator.userAgent,
        start = agent.indexOf('HUAWEI'),
        devices = navigator.userAgent.match(
            /ALP-|AMN-|ANA-|ANE-|ANG-|AQM-|ARS-|ART-|ATU-|BAC-|BLA-|BRQ-|CAG-|CAM-|CAN-|CAZ-|CDL-|CDY-|CLT-|CRO-|CUN-|DIG-|DRA-|DUA-|DUB-|DVC-|ELE-|ELS-|EML-|EVA-|EVR-|FIG-|FLA-|FRL-|GLK-|HMA-|HW-|HWI-|INE-|JAT-|JEF-|JER-|JKM-|JNY-|JSC-|LDN-|LIO-|LON-|LUA-|LYA-|LYO-|MAR-|MED-|MHA-|MLA-|MRD-|MYA-|NCE-|NEO-|NOH-|NOP-|OCE-|PAR-|PIC-|POT-|PPA-|PRA-|RNE-|SEA-|SLA-|SNE-|SPN-|STK-|TAH-|TAS-|TET-|TRT-|VCE-|VIE-|VKY-|VNS-|VOG-|VTR-|WAS-|WKG-|WLZ-|YAL/i
        )
    return start > -1 || devices !== null
}

export const isSafari = () => {
    // https://stackoverflow.com/questions/7944460/detect-safari-browser
    // This includes Chrome on IOS which seems to be Safari, So it's fully OK !
    const agent = window.navigator.userAgent
    return /^((?!chrome|android).)*safari/i.test(agent)
}

export const isFirefox = () => {
    const agent = window.navigator.userAgent
    return agent.indexOf('Firefox') > -1
}

export const isWebInspector = () => {
    // https://stackoverflow.com/questions/19877924/what-is-the-list-of-possible-values-for-navigator-platform-as-of-today
    // If we are in a web inspector, in our Nespresso context platform can be MacIntel or eventually Win32 for windows users
    const platform = window.navigator.platform
    return platform.indexOf('MacIntel') > -1 || platform.indexOf('Win32') > -1
}
